module.exports = __webpack_public_path__ + "static/img/e-learning_nocontent.9dab4302.svg";